import React from 'react';

import {Heading, Skeleton} from '@albert-io/atomic';
import {ListRowsSkeleton, SkeletonRow} from 'client/TeacherDashboard/components/ListRowsSkeleton';

// Rows-only placeholder for the in-list loading state (search / filter refetch), where the heading
// and controls already stay mounted — so a search shows skeleton rows, not a collapsing spinner.
export const AssignmentRowsSkeleton = () => <ListRowsSkeleton label='Loading assignments…' />;

/**
 * First-paint placeholder for the assignments view, matching its real layout (heading, status
 * segments + controls at 44px, rows) so tabs, counts, and rows reveal in place with no shift, no
 * "Status (0)" flash, and no tabs-before-empty-state flash (#19132).
 */
export const AssignmentsViewSkeleton = () => (
  <div aria-busy='true' className='gap-x3 pt-x4 flex flex-col'>
    <span className='sr-only' role='status'>
      Loading assignments…
    </span>
    <Heading as='h2' className='m-x0' size='s'>
      Assignments
    </Heading>
    <div aria-hidden='true' className='gap-x2 flex flex-wrap items-center justify-between'>
      <Skeleton className='h-[44px] w-[340px] max-w-full rounded-full' />
      <div className='gap-x1 flex items-center'>
        <Skeleton className='w-x10 rounded-x1 h-[44px]' />
        <Skeleton className='w-x8 rounded-x1 h-[44px]' />
        <Skeleton className='rounded-x1 h-[44px] w-[44px]' />
        <Skeleton className='w-x10 rounded-x1 h-[44px]' />
      </div>
    </div>
    <div aria-hidden='true' className='flex flex-col'>
      {['r1', 'r2', 'r3', 'r4', 'r5', 'r6'].map((key) => (
        <SkeletonRow key={key} />
      ))}
    </div>
  </div>
);
